import {
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Avatar,
    Divider,
 
} from '@mui/material'
import ContactsIcon from '@mui/icons-material/Contacts';
import EmailIcon from '@mui/icons-material/Email';


import StoreIcon from '@mui/icons-material/Store';

const ShopCntCardView = ({item}) => {


    const listStyles = {
        color: '#000',
        fontSize: '24px',
        fontFamily: 'sans-serif',
 
        padding: '0px',
       margin: '0px'
      }
  
   


    return(
        <>
        <div>
        <Divider variant='inset' component="li"/>
        <List className='contactInfocard'>
              <ListItem>
                    
                    <ListItemAvatar>
                        <Avatar><StoreIcon/></Avatar>
                        </ListItemAvatar>
                        <ListItemText style={listStyles} primary="Contact Info" />
                
                    
                  </ListItem>

                  <div>
                <Divider variant='inset' component="li"/>
                 <ListItem>
                    <ListItemAvatar>
                        <Avatar><ContactsIcon/></Avatar>
                    </ListItemAvatar>
                    <ListItemText style={listStyles} primary="MOBILE NO:" secondary={item.mobileNo} />
                </ListItem>
                <ListItem>
                    <ListItemAvatar>
                        <Avatar><EmailIcon/></Avatar>
                    </ListItemAvatar>
                    <ListItemText style={listStyles} primary="EMAIL ID:" secondary={item.email} />
                </ListItem>
                
                            </div>
                <Divider className='mt-3 mb-3'/>
                </List>
                            </div>
                        <h4>{item.status}</h4>
                        

                        

        </>
    )
}

export default ShopCntCardView